
import {
    defineComponent
} from 'vue';

import {
    Project
} from "@/helpers/interfaces";

export default defineComponent({
    props: {
        project: {
            type: Object as() => Project,
            required: true
        },
    }

});
